module.exports = __webpack_public_path__ + "img/social-media.3b4c595c.png";